// extracted by mini-css-extract-plugin
module.exports = {"row":"_6eb00b8e53--row--s6ayh","content":"_6eb00b8e53--content--30RhE"};